var map = {
	"./razzo-head-page-1.png": "7b12",
	"./razzo-head-page-2.png": "c523",
	"./razzo-head-page-3.png": "f4b8",
	"./razzo-head-page-4.png": "93e4",
	"./razzo-head-page.png": "9c6f",
	"./razzo1.png": "a8a1",
	"./razzo2.png": "e4c2",
	"./razzo3.png": "94838",
	"./razzo4.png": "dc98",
	"./razzo5.png": "7fde"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "201d";